import {
    type DimensionValue,
    StyleSheet
} from "react-native";
import type {
    SidebarRowMeasures,
    SidebarMeasures
} from "../../type";

export const SIDEBAR_SKELETON_WIDTHS: Array<DimensionValue> = [
    "72%",
    "56%",
    "64%",
    "48%"
];

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        minWidth: 0
    },
    row: {
        flexDirection: "row",
        alignItems: "center"
    },
    text: {
        flexShrink: 1,
        minWidth: 0,
        flexGrow: 1
    }
});

export const useStyles = ({
    rowMeasures,
    measures,
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
    rowMeasures: SidebarRowMeasures;
    measures: SidebarMeasures;
}) => {
    return {
        row: {
            paddingHorizontal: rowMeasures.inset,
            height: rowMeasures.height,
            gap: measures.gap
        },
        container: {
            gap: spaces.spacingXxs
        }
    };
};
export default stylesheet;
